import styled from 'styled-components';

import FeaturesWrap from 'components/Features/styled/FeaturesWrap';

export default styled.div`
  ${FeaturesWrap} {
    li {
      padding: 0 16px;
    }
  }

  padding-bottom: 40px;
`;
